export default __webpack_public_path__ + "./fonts/filtergray.1c69ec929ca25a300cd0749412233228.svg";